<template>
  <vs-row id="appSettingsPage" vs-type="flex" vs-w="12">
    <integration-variant-detail
      v-if="addNewDataSidebar"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      :integrationSettings="integrationSettings"
    />
    <integration-file-upload
      v-if="fileUploadModalSidebar"
      :isSidebarActive="fileUploadModalSidebar"
      @closeSidebar="toggleUploadSidebar"
      @getProducts="getProducts"
      :integrationId="$route.params.slug"
    />
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between">
      <vs-col vs-type="flex" vs-w="12">
        <div
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div
            class="mb-2"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span class="text-primary bold text-medium">
              {{ integrationSettings.integration.name }}
            </span>
            <div style="display: flex; gap: 8px">
              <vs-button
                type="filled"
                color="primary"
                icon-pack="feather"
                icon="icon-check-circle"
                :disabled="testingConnection"
                @click="testConnectionClick"
              >
                {{ testingConnection ? "Test Ediliyor..." : "Bağlantıyı Test Et" }}
              </vs-button>
              <vs-button
                type="gradient"
                color="transparent"
                icon-pack="feather"
                icon="icon-refresh-cw"
                @click="getProducts(true)"
              ></vs-button>
              <vs-button
                v-if="fieldConfig.showExcelActions"
                type="gradient"
                color="transparent"
                icon-pack="feather"
                icon="icon-file"
                @click="uploadFileModal()"
              ></vs-button>
              <vs-button
                v-if="fieldConfig.showExcelActions"
                type="gradient"
                color="transparent"
                icon-pack="feather"
                icon="icon-download"
                @click="generateExcel()"
              ></vs-button>
            </div>
          </div>
          <form data-vv-scope="form-pos-ip-settings">
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="mb-2"
              v-if="fieldConfig.fields.includes('isActive')"
            >
              <vs-col style="display: flex; align-items: center" vs-w="6">
                <span class="weight-600" style="margin-right: 8px"
                  >Entegrasyon Aktif:
                </span>
                <vs-switch class="ml-2" v-model="integrationSettings.isActive">
                  <span slot="true">Evet</span>
                  <span slot="false">Hayır</span>
                </vs-switch>
              </vs-col>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="my-2"
              v-if="fieldConfig.fields.includes('apiKey')"
            >
              <span class="weight-600">{{ fieldConfig.labels.apiKey || "Kullanıcı Adı" }}: </span>
              <vs-input v-model="integrationSettings.apiKey" class="w-full" />
              <span class="text-danger text-sm">{{
                errors.first("form-pos-ip-settings.API URL")
              }}</span>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="my-2"
              v-if="fieldConfig.fields.includes('externalRestaurantSecretKey')"
            >
              <span class="weight-600"
                >{{ fieldConfig.labels.externalRestaurantSecretKey || "Şifre" }}:
              </span>
              <vs-input
                v-model="integrationSettings.externalRestaurantSecretKey"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-pos-ip-settings.API URL")
              }}</span>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="my-2"
              v-if="fieldConfig.fields.includes('chainId')"
            >
              <span class="weight-600">Zincir Id: </span>
              <vs-input v-model="integrationSettings.chainId" class="w-full" />
              <span class="text-danger text-sm">{{
                errors.first("form-pos-ip-settings.API URL")
              }}</span>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="my-2"
              v-if="fieldConfig.fields.includes('externalRestaurantId')"
            >
              <span class="weight-600">Restoran ID: </span>
              <vs-input
                v-model="integrationSettings.externalRestaurantId"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-pos-ip-settings.API URL")
              }}</span>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="mb-2"
              v-if="fieldConfig.fields.includes('instantAccept')"
            >
              <vs-col style="display: flex; align-items: center" vs-w="6">
                <span class="weight-600" style="margin-right: 8px"
                  >Siparişi Anında Onayla:
                </span>
                <vs-switch
                  class="ml-2"
                  v-model="integrationSettings.instantAccept"
                >
                  <span slot="true">Evet</span>
                  <span slot="false">Hayır</span>
                </vs-switch>
              </vs-col>
            </vs-row>
            <vs-row
              vs-type="flex"
              vs-w="12"
              class="mb-2"
              v-if="fieldConfig.fields.includes('restaurantStatus')"
            >
              <vs-col style="display: flex; align-items: center" vs-w="6">
                <span class="weight-600">Restoran Statüsü: </span>
                <vs-switch
                  class="ml-2"
                  v-model="integrationSettings.restaurantStatus"
                >
                  <span slot="1">Aktif</span>
                  <span slot="0">Pasif</span>
                </vs-switch>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button color="success" @click="submitIntegrationSettings">
                Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between">
      <vs-col vs-type="flex" vs-w="12">
        <div
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <vs-table
            ref="table"
            :data="integrationProductList"
            style="overflow: visible"
          >
            <template slot="thead">
              <vs-th class="w-4/12">
                <vs-button icon-pack="feather" type="flat"
                  >{{ integrationSettings.integration.name }}
                </vs-button>
              </vs-th>
              <vs-th class="w-5/12">
                <vs-button color="primary" type="flat"> PickPos </vs-button>
              </vs-th>
              <vs-th
                class="w-5/12"
                v-if="fieldConfig.showProductStatusColumn"
              >
                <vs-button color="primary" type="flat"> Durum </vs-button>
              </vs-th>
              <vs-th>
                <vs-button icon-pack="feather" type="flat">İşlem </vs-button>
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td class="w-5/12">
                    <p class="font-medium truncate">
                      {{ tr.integrationProductName }}
                    </p>
                  </vs-td>
                  <vs-td class="w-5/12">
                    <div class="font-medium truncate mt-2" @click.stop>
                      <v-select
                        class="w-full"
                        placeholder="Ürün Seçimi"
                        :id="'id_' + tr.integrationProductId"
                        label="name"
                        :options="
                          tr.isRawMaterial ? rawMaterialList : productList
                        "
                        :reduce="(product) => product.id"
                        v-model="tr.productId"
                        :searchable="true"
                        :append-to-body="true"
                        :ref="'select_' + tr.integrationProductId"
                      />
                    </div>
                  </vs-td>
                  <vs-td
                    v-if="fieldConfig.showProductStatusColumn"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      height: 100%;
                    "
                    vs-w="6"
                  >
                    <vs-switch
                      v-model="tr.productStatus"
                      :ref="'status_' + tr.integrationProductId"
                      style="width: 75px !important"
                      color="success"
                    >
                      <span slot="true">Aktif</span>
                      <span slot="false">Pasif</span>
                    </vs-switch>
                  </vs-td>
                  <vs-td class="whitespace-no-wrap w-1/12">
                    <div style="display: flex; gap: 8px; align-items: center">
                      <vs-button
                        type="gradient"
                        color="success"
                        icon-pack="feather"
                        icon="icon-check"
                        @click="saveProduct(tr.integrationProductId)"
                      >
                      </vs-button>
                      <vs-button
                        v-if="fieldConfig.showProductInfoAction"
                        type="gradient"
                        color="warning"
                        icon-pack="feather"
                        icon="icon-info"
                        @click="getDetails(tr)"
                      >
                      </vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
      </vs-col>
    </vs-row>
  </vs-row>
</template>
<script>
import {
  getIntegrationSettings,
  upsertIntegrationSettings,
  getProducts,
  saveProduct,
  changeProductStatus,
  generateExcel,
  testConnection,
} from "@/api/Integration";
import { getAllActiveChilds } from "@/api/Product";
import IntegrationVariantDetail from "./IntegrationVariantDetail.vue";
import IntegrationFileUpload from "./IntegrationFileUpload.vue";
import { getRawMaterialNameList } from "@/api/RawMaterial";
import { getIntegrationFieldConfig } from "./integrationFieldConfig";
export default {
  components: {
    IntegrationVariantDetail,
    IntegrationFileUpload,
  },
  data() {
    return {
      integrationSettings: {},
      integrationSettingsRequest: {},
      productList: [],
      integrationProductList: [],
      addNewDataSidebar: false,
      fileUploadModalSidebar: false,
      sidebarData: {},
      rawMaterialList: [],
      testingConnection: false,
    };
  },
  computed: {
    fieldConfig() {
      const integrationType =
        this.integrationSettings && this.integrationSettings.integration
          ? this.integrationSettings.integration.integrationType
          : undefined;
      return getIntegrationFieldConfig(integrationType);
    },
  },
  created: async function () {
    await this.loadIntegrationSettings();
    await this.getProducts();
    await this.getAllActiveChilds();
  },
  methods: {
    async loadIntegrationSettings() {
      try {
        const response = await getIntegrationSettings(this.$route.params.slug);
        this.integrationSettings = response.data;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Entegrasyonlar yüklenirken bir hata oluştu!",
        });
      }
    },
    uploadFileModal() {
      this.fileUploadModalSidebar = true;
    },
    async testConnectionClick() {
      this.testingConnection = true;
      try {
        const response = await testConnection(this.$route.params.slug);
        const result = response && response.data;
        if (result && result.success) {
          this.$vs.notify({
            color: "success",
            title: "Bağlantı Başarılı!",
            text: result.message,
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Bağlantı Başarısız!",
            text: (result && result.message) || "Bilinmeyen hata.",
          });
        }
      } catch (e) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: e.message,
        });
      } finally {
        this.testingConnection = false;
      }
    },
    getDetails(data) {
      const selectComponent =
        this.$refs["select_" + data.integrationProductId][0];

      if (selectComponent.value == null) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Ürün seçimi bulunamadı!",
        });
        return;
      }

      this.saveProduct(data.integrationProductId);

      const selectedProduct = this.productList.find(
        (product) => product.id === selectComponent.value
      );

      const selectedProductName = selectedProduct ? selectedProduct.name : "";

      this.sidebarData = {
        integrationProductId: data.integrationProductId,
        integrationProductName: data.integrationProductName,
        productId: selectComponent.value,
        productName: selectedProductName,
      };
      this.toggleDataSidebar(true);
    },

    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    toggleUploadSidebar(val = false) {
      this.fileUploadModalSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    async saveProduct(id) {
      try {
        var integrationProduct = this.integrationProductList.find(
          (product) => product.integrationProductId === id
        );

        const selectComponent = this.$refs["select_" + id][0];
        // if (selectComponent.value == null) {
        //   this.$vs.notify({
        //     color: "danger",
        //     title: "Hata!",
        //     text: "Ürün seçimi bulunamadı!",
        //   });
        //   return;
        // }

        console.log(
          "Integration Product:",
          integrationProduct,
          "Selected Component Value:",
          selectComponent.value
        );

        let productId = 0;
        if (!integrationProduct.isRawMaterial) {
          productId = selectComponent.value;
        }

        let rawMaterialId = 0;
        if (integrationProduct.isRawMaterial) {
          rawMaterialId = selectComponent.value;
        }
        debugger;
        var response = await saveProduct(
          this.$route.params.slug,
          id,
          productId,
          rawMaterialId
        );
        if (response && response.status === 200) {
          this.$vs.notify({
            color: "success",
            title: "Başarılı !",
            text: "Ürün başarıyla kaydedildi.",
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + response.status,
            text: "Ürün kaydı başarısız !",
          });
        }
        if (this.fieldConfig.showProductStatusColumn) {
          const statusComponent = this.$refs["status_" + id][0];
          const statusResponse = await changeProductStatus(
            this.$route.params.slug,
            id,
            statusComponent.value
          );
          if (statusResponse && statusResponse.status === 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Ürün durumu güncellendi.",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + statusResponse.status,
              text: "Ürün durumu güncellemesi başarısız!",
            });
          }
        }
      } catch (e) {
        this.integrationProductList = null;
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    async getProducts(hardRefresh = false) {
      try {
        if (!this.integrationSettings.isActive) {
          return;
        }
        const response = await getProducts(
          this.$route.params.slug,
          hardRefresh
        );
        this.integrationProductList = response.data;
      } catch (e) {
        this.integrationProductList = null;
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    async getAllActiveChilds() {
      if (!this.integrationSettings.isActive) {
        return;
      }

      try {
        const response = await getAllActiveChilds();
        this.productList = response.data;
      } catch (e) {
        this.productList = null;
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }

      if (this.fieldConfig.usesRawMaterialMapping) {
        try {
          const response = await getRawMaterialNameList();
          this.rawMaterialList = response.data.filter(
            (item) => item.variants === null
          );
        } catch (e) {
          this.rawMaterialList = null;
          this.$fire({
            title: "Hata !",
            text: e.message,
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: e.message,
          });
        }
      }
    },
    async generateExcel() {
      try {
        const response = await generateExcel(this.$route.params.slug);
        if (response && response.data) {
          // If response.data is a base64 string:
          const binary_string = window.atob(response.data);
          const len = binary_string.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
          }
          const blob = new Blob([bytes], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "integration-products.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          this.$vs.notify({
            color: "success",
            title: "Başarılı!",
            text: "Excel dosyası indirildi.",
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata!",
            text: "Excel dosyası alınamadı.",
          });
        }
      } catch (e) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: e.message,
        });
      }
    },
    async submitIntegrationSettings() {
      this.integrationSettingsRequest = {
        externalRestaurantSecretKey:
          this.integrationSettings.externalRestaurantSecretKey,
        instantAccept: this.integrationSettings.instantAccept,
        restaurantStatus: this.integrationSettings.restaurantStatus ? 1 : 0,
        integrationId: this.integrationSettings.integration.id,
        chainId: this.integrationSettings.chainId,
        apiKey: this.integrationSettings.apiKey,
        externalRestaurantId: this.integrationSettings.externalRestaurantId,
        isActive: this.integrationSettings.isActive,
      };

      await upsertIntegrationSettings(this.integrationSettingsRequest)
        .then(async (res) => {
          if (res && res.status === 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Güncelleme İşlemi Başarılı !",
            });
            await this.getProducts();
            await this.getAllActiveChilds();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Güncelleme İşlemi Başarısız !",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
  },
};
</script>
<style>
.v-select .vs__dropdown-menu,
.vs__dropdown-menu {
  z-index: 999999 !important;
  position: absolute !important;
}
.v-select .vs__dropdown-menu {
  z-index: 99999 !important;
}
.sale-box-shadow,
.half-friendly-border,
.vs-table {
  overflow: visible !important;
}
</style>
